module.exports = __webpack_public_path__ + "img/couples-035.319321f5.jpg";